<template>
  <div class='table-box'>
    <global-tag>
      <el-form :inline='true' :model='searchlist' class='demo-form-inline' size='mini'>
        <el-form-item label='姓名:'>
          <el-input v-model='searchlist.customerName' placeholder='请输入'></el-input>
        </el-form-item>
        <el-form-item label='联系电话:'>
          <el-input v-model='searchlist.phone' placeholder='请输入'></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' icon='el-icon-search' @click='searchlistdata'>查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type='info' @click='searchlistReset'>重置
          </el-button>
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </global-tag>
    <div class='three'>
      <el-button type='primary' size='mini' @click="addDialog('新增')">新增
      </el-button>
    </div>
    <!-- 表格盒子 -->
    <div class='table_card'>
      <el-table :data='tableData' :header-cell-style="{ background: '#f8fafa' }" border highlight-current-row>
        <el-table-column fixed type="index" align="center" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="customerName" label="姓名" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="gender" label="性别" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? "女" : "男" }}
          </template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="customerTypeStr" label="用户类型" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="elderlyBelongCategory" label="所属类别" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-for="(item, index) in oldtypeLits" :key="index"><span
                v-if="scope.row.elderlyBelongCategory == item.dictCode">{{
                  item.dictLabel
                }}</span></span>
          </template>
        </el-table-column>
        <el-table-column align='center' label='操作' fixed='right' width="220">
          <template slot-scope='scope'>
            <button class='tabBtn tabBtn-edit' @click="showDialog('查看', scope.row)">查看</button>
            <button class='tabBtn tabBtn-edit' @click="showDialog('设备绑定', scope.row)">设备绑定</button>
            <button class='tabBtn tabBtn-delete' @click='deleteItem(scope.row.id)'>删除</button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination :page-size='pageConfig.pageSize' layout='total, prev, pager, next, jumper'
        @current-change='handleCurrentChange' :total='pageConfig.total'></el-pagination>
    </div>
    <addInfo :setTitle="dialogTitle" :showStatus="showDialogVisible" :formData="addForm"
      @updateShowStatus="updateShowStatus"></addInfo>
    <addPerson :showDialogVisible="addVisiable" @addClose="addClose"></addPerson>
  </div>
</template>

<script>
import '@/assets/css/system.css'
import { post } from '@/api/requrestHttp'
import addInfo from './components/addInfo.vue';
import addPerson from './components/addPerson.vue';
import exportVue from "@/utils/exportVue"
export default {
  components: { addInfo, addPerson },
  data() {
    return {
      addForm: {},
      dialogTitle: '新增',
      showDialogVisible: false,
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      oldtypeLits: [],
      addVisiable: false
    }
  },
  methods: {
    deleteItem(id) {
      this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await post('ypt/admin/all/customer/info/updateCustomerEquFlag', { id: id })
          if (res.code == 200) {
            this.getTableData()
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    async send() {
      let url
      if (this.dialogTitle === '新增') {
        url = '/rbac/admin/post/save'
      } else {
        url = '/rbac/admin/post/update'
      }
      const res = await post(url, this.addForm)
      this.getTableData()
      this.dialogClose()
    },
    dialogClose() {
      this.showDialogVisible = false
      this.addForm = {}
      this.$refs.dialogfrom.resetFields()
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getTableData()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getTableData()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    //获取列表数据
    async getTableData() {
      this.searchlist.isEquCustomer=1
      const { content } = await post('/ypt/admin/all/customer/info/findList', {
        ...this.searchlist,
        ...this.pageConfig
      })
      this.tableData = content.list || []
      this.pageConfig.total = content.count
    },
    async showDialog(type, row) {
      this.showDialogVisible = true
      this.dialogTitle = type
      this.addForm = {}
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/get",
          method: "POST",
          data: {
            id: row.id,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.addForm = res.content
          }
        })
    },
    updateShowStatus() {
      this.showDialogVisible = false
      this.formData={}
      this.getTableData()
    },
    getOlderList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.oldtypeLits = res.rows
            }
          }
        })
    },
    addDialog(){
      this.addVisiable=true
    },
    addClose(){
      this.addVisiable=false
      this.getTableData()
    }
  },

  mounted() {
    this.getTableData()
    this.getOlderList()
  }
}
</script>
<style scoped>
.tabBtn {
  font-size: 13px;
  margin: 0 3px;
}
</style>
